import { CommonRequestOptions, makeRequest } from './makeRequest';

export type TranslationSettings = {
   locale: string;
};

export type TranslationDict = {
   [key: string]: string;
};

export type TranslationsResponse = {
   translations: TranslationDict;
   translationSettings: TranslationSettings;
};

export async function getTranslations(
   common: CommonRequestOptions = {}
): Promise<TranslationsResponse> {
   return makeRequest('get', 'translations', common);
}

export async function editTranslationSettings(
   translationSettings: TranslationSettings,
   common: CommonRequestOptions = {}
) {
   return makeRequest('post', 'translations/settings', {
      ...common,
      body: translationSettings,
   });
}
